let observer: IntersectionObserver | null = null;
const callbacks = new Map<Element, (entry: IntersectionObserverEntry) => void>();

function getObserver(): IntersectionObserver | null {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
    return null;
  }

  if (!observer) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          const callback = callbacks.get(entry.target);
          if (!callback) {
            return;
          }

          callbacks.delete(entry.target);
          observer!.unobserve(entry.target);

          try {
            callback(entry);
          } catch (error) {
            console.warn('IntersectionObserver callback failed', error);
          }
        });
      },
      {
        threshold: 0.5,
      },
    );
  }

  return observer;
}

function observeVisibility(
  element: Element | null | undefined,
  callback: (entry: IntersectionObserverEntry) => void,
): () => void {
  const obs = getObserver();

  if (!obs || !element || typeof callback !== 'function') {
    return () => {};
  }

  callbacks.set(element, callback);
  obs.observe(element);

  return () => {
    callbacks.delete(element);
    try {
      obs.unobserve(element);
    } catch {}
  };
}

function unobserveVisibility(element: Element | null | undefined): void {
  if (!observer || !element) {
    return;
  }

  callbacks.delete(element);

  try {
    observer.unobserve(element);
  } catch {}
}

export { observeVisibility, unobserveVisibility };
